import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { PropTypes } from "prop-types";
import { useState } from "react";

//style
import css from "../../genericMagneticStyle.less"
import { useI18n } from "../../../i18n/useI18n";

const [HbrDrawer] =
    reactWrapper(["hbr-drawer"]);

const HelpDrawer = ({ openHelpDrawer }) => {
    const { tGenerics } = useI18n('generics');
    const [open, setOpen] = useState(true);

    const handleCloseClick = () => {
        setOpen(false);
        openHelpDrawer(false);
    }
    const handleDrawerShow = () => {
        setOpen(true);
    }
    return (
        <div className={css["help-drawer"]}>
            <HbrDrawer
                scrollAware={true}
                open={open}
                overlay={true}
                id={"drawer-help"}
                onHbr-hide={handleCloseClick}
                onHbr-show={handleDrawerShow}

            >
                {/* Title */}
                <div slot="label" className="hbr-css__layout-col-2xs">
                    <div className="hbr-css__text-heading-xl-bold">{tGenerics('help')}</div>
                    <div className="hbr-css__text-secondary-sm hbr-type-body3 subtitle">
                        {tGenerics('helpSubtitle')}
                    </div>
                </div>

                {/* Content */}
                <div
                    className="hbr-css__container-empty"
                >
                    {tGenerics('helpNoContent')}
                </div>
            </HbrDrawer>
        </div>
    )
}

HelpDrawer.propTypes = {
    openHelpDrawer: PropTypes.func
}
export default HelpDrawer;
